// extracted by mini-css-extract-plugin
export var backdropBlur = "_ei-0";
export var contentCard = "_ei-5";
export var frame = "_ei-2";
export var image = "_ei-4";
export var imagePane = "_ei-3";
export var modal = "_ei-1";